<template>
    <div class="card" v-if="crossfilter.visibleFlag === true" style="height: 101%">
        <div class="card-header d-flex justify-content-between">
            <div class="">{{crossfilter.vizTitle}}</div>
            
                <select v-model="salesmanData" class="c-s">
                    <option v-for="l1 in filterSalesman" v-bind:key="l1">{{l1}}</option>
                </select>
            <a v-on:click="commentBox(crossfilter)" class="txt-color-white right-padding-50">
                <i class="fa fa-lg fa-comments"></i>
            </a>
        </div>
        <div class="card-body">
            <div :id="id" ref="r1c1" class="mb-5">
                <div id='charts'>
                    <div id='year-chart' class='chart'>
                        <div class='title'>Revenue Wise Year-Month</div>
                    </div>
                    <div id='category-chart' class='chart'>
                        <div class='title'>Revenue Wise Sub Category</div>
                    </div>
                    <div id='orders-chart' class='chart'>
                        <div class='title'>Margin Wise Count Of Orders</div>
                    </div>
                    <div id='salesman-chart' class='chart'>
                        <div class='title'>Revenue Wise Sales Person</div>
                    </div>
                </div>
                <aside id='totals' class="ml-5">
                    <table class='table ml-5'>
                        <thead>
                            <tr>
                                <th>Year-Month</th>
                                <th>Salesman</th>
                                <th>Sub Category</th>
                                <th>Count Of Orders</th>
                                <th>Revenue</th>
                                <th>Margin</th>
                            </tr>
                        </thead>
                    </table>
                </aside>
                <div id='lists' class='ml-5'>
                    <div class="ml-5"><div id='salesman-list' class='list ml-5'></div></div>
                </div>
            </div>
        </div>
        <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
            <b-form-group label="Comment">
                <textarea rows="3" cols="40" v-model="cmnt"
                          placeholder="Write a comment..."></textarea>
            </b-form-group>
        </b-modal>
    </div>
</template>
<script>
import {FwVizChartInfo} from "../models";
import axios from "axios";

export default {
        name: 'Crossfilter',
        props: {
            crossfilter: Object
        },
        data: () => ({
            salesmanData:[],
            filterSalesman:'',
            showModal: false,
            cmnt: "",
            annotations: [],
            searching: false,
            annotationTitle: '',
            id: `VIZ-${new Date().getTime()}`
        }),
        methods: {
            loadSalesman: function () {
                axios.get('/api/salesman-list/')
                .then(res => {
                    this.salesmanData = res.data
                    this.filterSalesman = Array.from(new Set(this.salesmanData.map(c => c.dim1).filter(x => x != null)))
                    console.log("Salesman data:", this.filterSalesman)  
                }, err => {
                    console.log('Error in fetching record', err)
                })
            },

            commentBox: function (what) {
                console.log(`ENTERED into the commentBox function(${what.menuName}, ${what.screenName})`)
                this.cmt = '';
                this.pg = what.menuName;
                this.section = what.screenName;
                this.annotationHeader = "User Annotations";
                this.annotationTitle = this.annotationHeader + '->' + this.pg + '->' + this.section
                this.$refs['comment-box'].show()
            },

            postAnnotation: function () {
                const url = '/api/annotation';
                const data = {
                    userId: 1,
                    userName: "Admin",
                    page: this.pg,
                    section: this.section,
                    comment: this.cmnt
                };
                axios.post(url, data)
                    .then(() => {
                       this.$store.dispatch('loadAnnotations')
                    }, e => {
                        this.$commonFn.auditLog(menuSyspk,menu, subMenu, "", "POST", e)
                        console.error('error in updating annotations', e)
                    })
                let menu = this.pg;
                let subMenu = this.section;
                let menuSyspk = this.menuSyspk

              console.log("the menus and submenus for Audit log is", menuSyspk,menu, subMenu)

                this.$commonFn.auditLog(menuSyspk,menu, subMenu, "", "POST", "Success")
            },

        },
        created() {
            this.loadSalesman()
          console.log('cf2', 'load state'); this.$store.dispatch("loadState").then(() => {
                let allVizType = this.$store.state.vizType
                let v = this.crossfilter
                let margin = {
                    top: v.pmTop,
                    right: v.pmRight,
                    bottom: v.pmBottom,
                    left: v.pmLeft
                }

                let vizId = v.viztypeId
                let filter = allVizType.filter(t => t.viztypeId === vizId)[0];
                let vizname = filter.viztypeClassName
                console.log("vizName in vue",vizname)
                let vizFunction = filter.viztypeFunctionName

                let divId = this.$refs.r1c1

                let vizunit = v.positionLogical

                let getChartInfo = (vizunit) => {
                    let f = v
                    if (f.length === 0) return new FwVizChartInfo(vizunit, margin, {}, false, [])
                    return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f)
                }

                this.position = getChartInfo(vizunit)

                let chartData = this.position
                console.log("The chart data is" , chartData, vizname, divId)

                setTimeout(() => {
                    this.$commonFn.renderChart(vizname, chartData, divId, vizFunction);
                }, 300)

            })

        }
    }
</script>
<style>
    .cobackground {
        fill: #eee;
    }

    text.active {
        fill: red;
    }
    .c-s {
        margin-top: -7px;
        margin-left: 500px;
        height:30px
    }
    .chart {
        display: inline-block;
        margin-bottom: 20px;
    }
    .brush-handle {
        fill: #eee;
        stroke: #666;
    }
    #lists {
        height: 300px;
        width: 650px;
        overflow: scroll;
        background-color: white;
    }
    aside {
        left: 358px;
        position: sticky;
        top: 0;
        white-space: nowrap;
        width: 520px;
        y-overflow: scroll;
    }
    #salesman-list div.time {
        width: 50px;
        text-align: left;
        border-bottom: solid;
        border-width: 1px;
    }
    #salesman-list div.category {
        width: 100px;
        text-align: left;
        border-bottom: solid;
        border-width: 1px;
    }
    #salesman-list .salesman div {
        display: inline-block;
        width: 100px;
        padding-right: 0px;
        border-bottom: solid;
        border-width: 1px;
    }
    #salesman-list div.orders {
        width: 70px;
        text-align: right;
        border-bottom: solid;
        border-width: 1px;
    }
</style>